(function (angular, location) {
  "use strict";

  angular.module("Toyota.Services").service("ModalService", [
    "$rootScope",
    function ($rootScope) {
      var exports = this;

      var registeredModals = [];
      var modalsToOpen = [];

      var flush = function (modalId) {
        modalsToOpen = modalsToOpen.filter(function (el) {
          return el.modalId !== modalId;
        });
      };

      var isModalToOpen = function (modalId) {
        return (
          modalsToOpen.findIndex(function (el) {
            return el.modalId === modalId;
          }) > -1
        );
      };

      var openModal = function (modalId, preventUrlFragment) {
        $rootScope.$broadcast("modal-open", modalId, preventUrlFragment);
      };

      var openModalTransitionless = function (modalId, preventUrlFragment) {
        $rootScope.$broadcast("modal-open-transitionless", modalId, preventUrlFragment);
      };

      exports.isModalRegistered = function (modalId) {
        return registeredModals.indexOf(modalId) > -1;
      };

      exports.isModalOpen = function (modalId) {
        return location.hash === "#" + modalId;
      };

      exports.preventReopenOnReload = function () {
        var url = location.pathname + location.search;
        history.replaceState(undefined, undefined, url);
      };

      exports.registerModal = function (modalId) {
        if (exports.isModalRegistered(modalId)) {
          throw new Error("Modal already registered: " + modalId);
        }

        registeredModals.push(modalId);

        if (isModalToOpen(modalId)) {
          flush(modalId);
          openModal(modalId);
        }
      };

      exports.openModal = function (modalId, preventUrlFragment) {
        if (!exports.isModalRegistered(modalId)) {
          modalsToOpen.push({ modalId: modalId, transitionless: false });
          return;
        }

        openModal(modalId, preventUrlFragment);
      };

      exports.openModalTransitionless = function (modalId, preventUrlFragment) {
        if (!exports.isModalRegistered(modalId)) {
          modalsToOpen.push({ modalId: modalId, transitionless: true });
          return;
        }

        openModalTransitionless(modalId, preventUrlFragment);
      };

      exports.closeModal = function (modalId) {
        $rootScope.$broadcast("modal-close", modalId);
      };

      exports.resetModalScrollTop = function (modalId) {
        $rootScope.$broadcast("modal-reset-scroll-top", modalId);
      };

      exports.updateModalHeaderConfig = function (modalId, title, leftAlign, removeClose) {
        $rootScope.$apply(
          $rootScope.$broadcast("modal-update-header-config", {
            modalId: modalId,
            title: title,
            leftAlign: leftAlign,
            removeClose: removeClose,
          })
        );
      };

      return exports;
    },
  ]);
})(window.angular, window.location);
